'use strict';

// @flow
import $ from 'jquery';

function GalleryDialogController($scope, $mdDialog, ClipArtImages) {
  'ngInject';

  $scope.isDialogLoading = true;
  $scope.images = { categories: [] };
  $scope.currentImages = [];
  $scope.selectedCategorie = 0;
  $scope.selectedImage = null;

  $scope.getImages = () => {
    $scope.images = ClipArtImages.get(() => {
      $scope.isDialogLoading = false;

      $scope.selectCategory(0);
    });
  };

  $scope.hide = () => {
    $mdDialog.hide();
  };

  $scope.cancel = () => {
    $mdDialog.cancel();
  };

  $scope.select = image => {
    $mdDialog.hide(image);
  };

  $scope.selectCategory = id => {
    $scope.selectedCategorie = id;

    $scope.currentImages = $scope.images.categories.filter(item => {
      return item.id === id;
    })[0].images;
  };

  $scope.selectImage = image => {
    $scope.selectedImage = image;
  };

  // Init dialog
  $scope.getImages();
}

export default class ImagesController {
  $state
  $scope
  $rootScope
  $mdDialog
  canvas

  /*@ngInject*/
  constructor($state, $scope, $rootScope, $mdDialog, Canvas) {
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$mdDialog = $mdDialog;
    this.canvas = Canvas;
  }

  $onInit = () => {
    this.$scope.$parent.isZIndexToolbarVisible = false;
    this.$scope.isToolboxVisible = false;
    this.$scope.currentItem = null;
    this.$scope.modelBinding = {
      size: 0,
      rotation: 0
    };

    this.canvas.events.addListener('canvas.onItemSelected', this.onCanvasItemSelected);
    this.canvas.events.addListener('canvas.onItemUnselected', this.onCanvasItemUnselected);
    const onArrange = this.$rootScope.$on('onArrange', this.onArrange);

    this.$scope.$on('$destroy', () => {
      this.canvas.events.removeListener('canvas.onItemSelected', this.onCanvasItemSelected);
      this.canvas.events.removeListener('canvas.onItemUnselected', this.onCanvasItemUnselected);
      onArrange();
    });
  }

  addImageBox = (file, invalidFiles) => {
    this.upload(file, invalidFiles, image => {
      this.canvas.addCustomImage(image);
    });
  }

  removeImageBox = () => {
    this.canvas.removeCustomImage(this.$scope.currentItem);
  }

  setGalleryImage = fileName => {
    let path = '/assets/images/clipart-images/' + fileName;

    const imageElement = new Image();
    imageElement.onload = () => {
      const item = this.canvas.addCustomImage(imageElement);
      this.onCanvasItemSelected({ item });
    };
    imageElement.src = path;
  }

  selectImageFromGallery = ev => {
    this.$mdDialog
      .show({
        controller: GalleryDialogController,
        template: require('./images.gallery.dialog.html'),
        parent: $(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: false
      })
      .then(
        image => {
          // Image selected
          this.setGalleryImage(image);
        },
        () => {
          // Cancelled
        }
      );
  }

  upload = (file, invalidFiles, handler) => {
    if(invalidFiles.length > 0) {
      this.$rootScope.fileUploadRejected();
      return;
    }

    if(file == null) return;

    try {
      let reader = new FileReader();
      reader.onload = (theFile => {
        return e => {
          let imageSource = e.target.result;
          this.$rootScope.log(imageSource);
          let imageElement = new Image();
          imageElement.onload = () => {
            handler(imageElement);
          };
          imageElement.src = imageSource;
        };
      })(file);

      reader.readAsDataURL(file);
    } catch(e) {
      this.$rootScope.log(e);
    }
  }

  onCanvasItemSelected = e => {
    let item = e.item;

    if(item.type != 'image') {
      this.$rootScope.$apply(() => {
        this.$scope.$parent.isZIndexToolbarVisible = false;
        this.$scope.isToolboxVisible = false;
      });
      return;
    }

    this.$rootScope.safeApply(() => {
      this.$scope.$parent.isZIndexToolbarVisible = true;
      this.$scope.isToolboxVisible = true;
      this.$scope.currentItem = item;

      this.$scope.modelBinding.size = item.size * 100;
      this.$scope.modelBinding.rotation = item.rotation;
    });
  }

  onCanvasItemUnselected = e => {
    this.$rootScope.safeApply(() => {
      this.$scope.$parent.isZIndexToolbarVisible = false;
      this.$scope.isToolboxVisible = false;
      this.$scope.currentItem = null;
    });
  }

  onImageSizeChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.size = this.$scope.modelBinding.size / 100;
    this.$rootScope.log('Image size: ' + this.$scope.currentItem.size);
    this.canvas.renderStage();
  }

  onImageRotationChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.rotation = this.$scope.modelBinding.rotation;
    this.canvas.renderStage();
  }

  onArrange = (event, action) => {
    if(!this.$scope.currentItem) return;
    this.canvas.applyZIndex(this.$scope.currentItem, action);
  }
}



// WEBPACK FOOTER //
// ./client/app/configurator/images/images.controller.js